import { createAuthManager, type User } from '@aleph-alpha/lib-auth';

export const guardForCallbackPage = async (
  userManager: ReturnType<typeof createAuthManager>,
  callback: (user?: User) => Promise<void> | void
) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const user = (await userManager.signinCallback(window.location.href))!;
  await callback(user);
};
